<template>
  <b-card no-body>
    <b-card-header class="d-flex align-items-center justify-content-between">
      <b-card-title>Son Yayınlar</b-card-title>
      <b-card-sub-title
        style="margin-top: 4px"
        class="font-small-3"
      >
        Son 10 Yayın
      </b-card-sub-title>
    </b-card-header>
    <b-table
      striped
      responsive
      :items="dataList"
      :fields="fields"
    >
      <template #cell(title)="data">
        <b-link :to="'/topics/view/' + data.item.id">
          <div class="font-small-3 text-body">
            {{ data.item.title }}
          </div>
          <div class="font-small-2 text-warning">
            {{ data.item.sites.company }} | {{ data.item.sites.site_name }}
          </div>
        </b-link>
      </template>
      <template #cell(published)="data">
        <div>
          <b-badge
            variant="light-success"
            class="w-100"
          >
            {{ moment(data.item.published).format('DD.MM.YYYY HH:mm') }}
          </b-badge>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BTable, BCardSubTitle, BLink, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'TablePublished',
  components: {
    BBadge,
    BCard,
    BCardHeader,
    BCardTitle,
    BTable,
    BCardSubTitle,
    BLink,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'Konu',
        },
        {
          key: 'published',
          label: 'Yayınlandı',
          thClass: 'width-100 text-nowrap text-right',
          tdClass: 'width-100 text-nowrap text-right',
        },
      ],
    }
  },
}
</script>
